// Function to filter out conflicts based on section_ids and types
export const filterOutConflicts = (conflicts, section_ids = [], types = []) => {
  const conflict_list = Array.isArray(conflicts) ? conflicts : [];
  const has_section_ids = Array.isArray(section_ids) && section_ids.length > 0;
  const has_types = Array.isArray(types) && types.length > 0;

  if (!has_section_ids && !has_types) return conflict_list;

  return conflict_list.filter(conflict => {
    const conflict_sections = Array.isArray(conflict.sections) ? conflict.sections : [];
    const matches_section = has_section_ids && conflict_sections.some(id => section_ids.includes(id));
    const matches_type = has_types && types.includes(conflict.type);

    if (has_section_ids && has_types) return !(matches_section && matches_type);
    if (has_section_ids) return !matches_section;
    return !matches_type;
  });
}
